/**
 * Wallet Balance Constants
 *
 * Constants for the wallet balance component.
 */

export const SELECTED_PERIOD_KEY = "smoothie-selected-period"
